import { useMemo } from 'react';

import { ICreditCondition } from '@r1-frontend/api-domru/payments/v1/credits/condition';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import format from '@r1-frontend/ui-react/components/costs/Cost/format';
import { TGuideItem } from '@r1-frontend/ui-react/components/Guide/GuideItem';
import { ClipboardTick } from '@r1-frontend/ui-react/components/svg/content';
import { Truck } from '@r1-frontend/ui-react/components/svg/delivery';
import { Coin, ReceiptItem } from '@r1-frontend/ui-react/components/svg/money';
import { Timer } from '@r1-frontend/ui-react/components/svg/time';
import { PersonalCard } from '@r1-frontend/ui-react/components/svg/users';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { MDASH, NBSP } from '@r1-frontend/ui-react/tokens/symbols';

import { setIsShowOptionSelect } from '~/src/features/work-in-home-ab/components/Description/components/Credit/context/actions';
import { useContextDispatch } from '~/src/features/work-in-home-ab/components/Description/components/Credit/context/hooks';

export const useCreditGuide = (selectedCreditCondition: ICreditCondition | null): TGuideItem[] => {
    const dispatch = useContextDispatch();

    const guideItems: TGuideItem[] = useMemo(() => {
        return [
            {
                isActive: true,
                Icon: Coin,
                title: 'Выберите рассрочку как вариант приобретения',
                description: <ListContainer $direction={'column'} $wrap={'nowrap'} $size={8}>
                    <Paragraph4 $color={COLORS.TextInfo}>
                        Минимальный платёж и&nbsp;период предоставления рассрочки будут точно рассчитаны после заполнения анкеты.
                    </Paragraph4>
                    {selectedCreditCondition && (
                        <ButtonGroup>
                            <Button size={'small'} bType={'secondary'} onClick={() => dispatch(setIsShowOptionSelect(true))}>
                                {`${format(selectedCreditCondition.pay, { monthly: true })} на ${selectedCreditCondition.duration} мес.`}
                            </Button>
                        </ButtonGroup>
                    )}
                </ListContainer>,
            },
            {
                isActive: false,
                Icon: PersonalCard,
                title: 'Заполните анкету',
                description: `Загрузите свои данные с${NBSP}Госуслуг${NBSP}${MDASH} это может занять около 3-5${NBSP}минут. Или заполните анкету самостоятельно.`,
            },
            {
                isActive: false,
                Icon: Timer,
                title: 'Дождитесь одобрения банка',
                description: `После заполнения заявки дождитесь ответа банка в${NBSP}смс. Обычно это занимает около 3${NBSP}минут.`,
            },
            {
                isActive: false,
                Icon: ClipboardTick,
                title: `Оформите заявку на${NBSP}визит инженера`,
                // eslint-disable-next-line max-len
                description: `После одобрения заявки, вы${NBSP}сможете выбрать время для визита инженера. Он${NBSP}привезёт оборудование, все нужные документы, сделает фото паспорта и${NBSP}всё настроит.`,
            },
            {
                isActive: false,
                Icon: Truck,
                title: 'Получите заказ',
                description: `Главное, чтобы заказ получали вы${NBSP}по${NBSP}своему паспорту. Кто-то другой заказ получить не${NBSP}сможет.`,
            },
            {
                isActive: false,
                Icon: ReceiptItem,
                title: `Платите в${NBSP}рассрочку`,
                description: (
                    <Paragraph4 $color={COLORS.TextInfo}>
                        В течение выбранного срока с{NBSP}вашего счета в{NBSP}банке будут списываться ежемесячные платежи.{' '}
                        <a href={'https://www.klookva.ru/credits/domru/'} rel='noreferrer'>
                            Подробнее
                        </a>
                    </Paragraph4>
                ),
            },
        ];
    }, [selectedCreditCondition]);

    return guideItems;
};
